import { render, staticRenderFns } from "./OldVideos.vue?vue&type=template&id=29bd8a54&scoped=true&"
import script from "./OldVideos.vue?vue&type=script&lang=js&"
export * from "./OldVideos.vue?vue&type=script&lang=js&"
import style0 from "./OldVideos.vue?vue&type=style&index=0&id=29bd8a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd8a54",
  null
  
)

export default component.exports